module.exports = __webpack_public_path__ + "img/show.3d93a503.svg";